import * as React from "react"
import { graphql } from "gatsby"
import Slider from "react-slick"
import { Text, Box, Space, Button, Flex, Heading } from "./ui"
import { convertDate } from "../helper-functions"
import { slickArrow } from "./feedback-preview-list-section.css"
import SectionLayout from "./section-layout"

function NextArrow(props) {
  const { className, style, onClick } = props
  let mergedClassName = `${className} ${slickArrow}`
  return <div className={mergedClassName} style={style} onClick={onClick} />
}

function PrevArrow(props) {
  const { className, style, onClick } = props
  let mergedClassName = `${className} ${slickArrow}`
  return <div className={mergedClassName} style={style} onClick={onClick} />
}

function FeedbackPreview(props) {
  return (
    <Box>
      <Text>
        <div
          dangerouslySetInnerHTML={{
            __html: props.body,
          }}
        />
      </Text>
      <Text>
        {props.name &&
          props.date &&
          `- ${props.name} am ${convertDate(props.date)}`}
      </Text>
    </Box>
  )
}

export default function FeedbackPreviewListSection(props) {
  var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
    autoplay: true,
    autoplaySpeed: 8000,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  }

  return (
    <SectionLayout index={props.index}>
      <Flex variant={"column"}>
        <Box>
          <Flex variant={"center"}>
            <Text variant="subhead">{props.title}</Text>
          </Flex>
          <Space size={5} />
          <Slider {...settings}>
            {props.content.map((item, index) => (
              <FeedbackPreview key={item.id} {...item} />
            ))}
          </Slider>
        </Box>
        {props.link && (
          <>
            <Space size={3} />
            <Button to={props.link.href}>{props.link.text}</Button>
          </>
        )}
      </Flex>
    </SectionLayout>
  )
}

export const query = graphql`
  fragment FeedbackPreviewListSectionContent on FeedbackPreviewListSection {
    content {
      date
      name
      body
    }
    title
    link {
      href
      text
    }
  }
`
